export type CrossIconProps = React.SVGProps<SVGSVGElement>;

export function CrossIcon(props: CrossIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <rect
        x="2.10059"
        y="4.92892"
        width="4"
        height="24"
        transform="rotate(-45 2.10059 4.92892)"
        fill="currentColor"
      />
      <rect
        x="19.071"
        y="2.10049"
        width="4"
        height="24"
        transform="rotate(45 19.071 2.10049)"
        fill="currentColor"
      />
    </svg>
  );
}
